/**
 * @file Join code / code related queries.
 */

import gql from 'graphql-tag';

import {
  WebGalleryAlbumBaseDetails,
  WebGalleryAlbumPrices,
} from '../fragments/album';
import { WebGalleryAlbumFolderFieldDetails } from '../fragments/album-folder';

export const JoinCodeByCodeForWebGalleryDiscovery = gql`
  query joinCodeByCodeForWebGalleryDiscovery($code: String!) {
    joinCodeByCode(code: $code) {
      id
      album {
        id
        ...WebGalleryAlbumBaseDetails
        creator {
          id
          slug
        }
      }
      album_folder {
        id
        name
        join_code
        album_type
        album_subtype
        ...WebGalleryAlbumFolderFieldDetails
        account {
          id
          slug
        }
      }
    }
  }
  ${WebGalleryAlbumBaseDetails}
  ${WebGalleryAlbumFolderFieldDetails}
`;

export const JoinCodeByCodeForAdWidget = gql`
  query joinCodeByCodeForAdWidget($code: String!) {
    joinCodeByCode(code: $code) {
      album {
        id
        join_code
        subscription_album_folder {
          id
          price {
            value
          }
        }
        ...WebGalleryAlbumPrices
      }
      album_folder {
        id
        join_code
      }
    }
  }
  ${WebGalleryAlbumPrices}
`;
